import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { AtomModule } from '../atom/atom.module'

const Components = [
  // LayoutAlphaComponent,
  // LayoutBetaComponent,
  // NotificationButtonAlphaComponent,
  // ProfileButtonAlphaComponent,
  // SearchBoxAlphaComponent,
  // FooterComponent,
  // SearchBannerComponent,
  // ProductComponent,
  // BillingFormComponent,
  // OrderSummaryComponent,
  // UserTagsComponent,
  // GameFeatureCardComponent,
  // ReviewCardComponent,
  // RecentCardComponent,
  // VideoPlayerComponent,
  // GameCardBetaComponent,
  // GameCardGammaComponent,
  // GameCardAlphaComponent,
  // ReviewsGraphComponent,
  // GameCardDeltaComponent,
  // GameCardEpsilonComponent,
  // ExtensionsCardComponent,
  // PlayOptionCardComponent,
  // ConfigurationCardComponent,
  // ReviewCardAlphaComponent,
  // GameAdAlphaComponent,
  // GameAdBetaComponent,
  // GameAdGammaComponent,
]

@NgModule({
  declarations: [...Components],
  imports: [AtomModule],
  providers: [],
  exports: [...Components, AtomModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MoleculeModule {}
